
























import { Component, Mixins } from 'vue-property-decorator'
import { Getter } from 'vuex-class'

// Mixins
import Errors from '@/mixins/Errors'
import Form from '@/mixins/Form'

// Components
import InfoBox from '@/components/common/InfoBox.vue'

@Component({
  components: {
    InfoBox
  }
})
export default class AddTeamMemberForm extends Mixins(Errors, Form) {
  email: string = null
  userNotFound: boolean = false

  @Getter('token') token

  cancel() {
    this.$emit('close')
  }

  async add() {
    try {
      this.userNotFound = false
      this.formLoading = true
      const res = await this.$api.team.addMember(this.token, this.email)
      this.$emit('add')
      this.$emit('close')
    } catch (error) {
      this.userNotFound = true
      this.email = null
    } finally {
      this.formLoading = false
    }
  }
}
